<div
	[formGroup]="filterForm"
	class="h-full mt-24px pb-[100px] px-12px custom-filter"
>
	<div class="flex justify-between items-center">
		<h1 class="tw-font-bold mb-0 font-semibold text-[24px]">
			{{ 'GENERAL_LABELS.FILTRATION' | translate }}
		</h1>
		<button *ngIf="filterCount" (click)="resetFilter()" class="flex text-link">
			{{ 'ACTIONS.RESET' | translate }}
			<img
				class="align-middle mx-2"
				src="assets/images/icon-reset.svg"
				alt="icon"
			/>
		</button>
	</div>
	<div class="mt-24px">
		<p class="text-[18px] ltr:font-DIN-Bold font-bold rtl:font-medium">
			{{ 'GENERAL_LABELS.DATE_RANGES' | translate }}
		</p>
		<app-custom-datepicker
			[defaultValue]="getController('dateFrom').value"
			label="GENERAL_LABELS.START_DATE"
			(dateValue)="getController('dateFrom').setValue($event)"
		></app-custom-datepicker>
		<app-custom-datepicker
			[defaultValue]="getController('dateTo').value"
			label="GENERAL_LABELS.END_DATE"
			(dateValue)="getController('dateTo').setValue($event)"
		></app-custom-datepicker>
		<mat-error
			*ngIf="
				getController('dateTo').value < getController('dateFrom').value &&
				getController('dateTo').value
			"
		>
			<div class="whitespace-nowrap">
				{{ 'VALIDATION.END_DATE_ERROR' | translate }}
			</div>
		</mat-error>
	</div>
	<div class="w-100 h-[1px] bg-secondry-color-Gray my-[16px]"></div>
	<div class="mt-24px">
		<div>
			<p class="text-[18px] ltr:font-DIN-Bold font-bold rtl:font-medium">
				{{ 'STORE.PRODUCT_LIST.CATEGORY' | translate }}
			</p>
			<mat-form-field appearance="outline" class="w-full custom-autocomplete">
				<button matSuffix mat-icon-button>
					<img class="w-3" src="assets/images/arrow.png" />
				</button>
				<mat-select
					formControlName="categoryId"
					panelClass="my-0 mx-24px custom-ed-hight custom-width   "
					[placeholder]="
						getController('categoryId')?.value
							? this.translate.currentLang == 'en'
								? categoryValue?.name?.en
								: categoryValue?.name?.ar
							: ('STORE.PRODUCT_FILTER.CHOOSE_CATEGORY' | translate)
					"
				>
					<mat-select-trigger class="text-main-color-black mx-2">
						{{
							this.translate.currentLang == 'en'
								? categoryValue?.name?.en
								: categoryValue?.name?.ar
						}}
					</mat-select-trigger>
					<div class="select-container">
						<mat-form-field
							class="w-[90%] ltr:ms-[12px] rtl:me-[12px] mt-2 bg-light-grey text-main-color-black relative overflow-hidden"
							appearance="outline"
						>
							<div>
								<img
									class="absolute ltr:left-[7px] rtl:right-[7px] inline-block top-[15px]"
									src="./assets/images/search-normal.svg"
									alt=""
								/>
							</div>
							<input
								matInput
								type="text"
								(keydown)="$event.stopPropagation()"
								[formControl]="categoryKeyWord"
								placeholder="{{ 'OFFERS.SEARCH' | translate }}"
								class="absolute w-[80%] ltr:left-10 rtl:right-10"
							/>
							<img
								*ngIf="categoryKeyWord.value"
								(click)="categoryKeyWord.setValue('')"
								class="cursor-pointer absolute ltr:right-3 rtl:left-3 top-[15px] inline-block"
								src="./assets/images/close-square.svg"
								alt=""
							/>
						</mat-form-field>

						<div class="overflow-y-auto custom-mat-option">
							<ng-container *ngFor="let category of categoryList">
								<mat-option
									(click)="
										filterForm.controls['categoryId'].setValue(category.id);
										getCategoryList(getController('categoryId').value, '', 1);
										categoryValue = category
									"
									[value]="category.id"
								>
									{{
										translate.currentLang == 'en'
											? category?.name?.en
											: category?.name?.ar
									}}
								</mat-option>
							</ng-container>
							<mat-option
								disabled
								class="only-check"
								*ngIf="!categoryList?.length"
							>
								{{ 'GENERAL.NO_DATA_FOUND' | translate }}
							</mat-option>
						</div>
					</div>
				</mat-select>
			</mat-form-field>

			<!-- SUB CATEORY  -->
			<mat-form-field appearance="outline" class="w-full custom-autocomplete">
				<button matSuffix mat-icon-button>
					<img class="w-3" src="assets/images/arrow.png" />
				</button>
				<mat-select
					formControlName="subCategoryId"
					panelClass="my-0 mx-24px custom-ed-hight custom-width   "
					[placeholder]="
						getController('subCategoryId')?.value
							? this.translate.currentLang == 'en'
								? subCategory?.name?.en
								: subCategory?.name?.ar
							: ('STORE.PRODUCT_FILTER.CHOOSE_SUB_CATEGORY' | translate)
					"
				>
					<mat-select-trigger class="text-main-color-black mx-2">
						{{
							this.translate.currentLang == 'en'
								? subCategory?.name?.en
								: subCategory?.name?.ar
						}}
					</mat-select-trigger>
					<div class="select-container">
						<mat-form-field
							class="w-[90%] ltr:ms-[12px] rtl:me-[12px] mt-2 bg-light-grey text-main-color-black relative overflow-hidden"
							appearance="outline"
						>
							<div>
								<img
									class="absolute ltr:left-[7px] rtl:right-[7px] inline-block top-[15px]"
									src="./assets/images/search-normal.svg"
									alt=""
								/>
							</div>
							<input
								matInput
								type="text"
								(keydown)="$event.stopPropagation()"
								[formControl]="keyWordSubCategory"
								placeholder="{{ 'OFFERS.SEARCH' | translate }}"
								class="absolute w-[80%] ltr:left-10 rtl:right-10"
							/>
							<img
								*ngIf="keyWordSubCategory.value"
								(click)="keyWordSubCategory.setValue('')"
								class="cursor-pointer absolute ltr:right-3 rtl:left-3 top-[15px] inline-block"
								src="./assets/images/close-square.svg"
								alt=""
							/>
						</mat-form-field>

						<div class="overflow-y-auto custom-mat-option">
							<ng-container *ngFor="let category of subCategoryList">
								<mat-option
									(click)="
										filterForm.controls['subCategoryId'].setValue(category.id);
										getCategoryList(
											getController('subCategoryId').value,
											'',
											2
										);
										subCategory = category
									"
									[value]="category.id"
								>
									{{
										translate.currentLang == 'en'
											? category?.name?.en
											: category?.name?.ar
									}}
								</mat-option>
							</ng-container>
							<mat-option
								disabled
								class="only-check"
								*ngIf="!subCategoryList?.length"
							>
								{{ 'GENERAL.NO_DATA_FOUND' | translate }}
							</mat-option>
						</div>
					</div>
				</mat-select>
			</mat-form-field>

			<mat-form-field appearance="outline" class="w-full custom-autocomplete">
				<button matSuffix mat-icon-button>
					<img class="w-3" src="assets/images/arrow.png" />
				</button>
				<mat-select
					formControlName="subSubCategoryId"
					[hideSingleSelectionIndicator]="true"
					panelClass=" my-0 mx-24px custom-ed-hight custom-width"
					[placeholder]="
						getController('subSubCategoryId')?.value
							? this.translate.currentLang == 'en'
								? subSubcategory?.name?.en
								: subSubcategory?.name?.ar
							: ('STORE.PRODUCT_FILTER.CHOOSE_SUB_SUB_CATEGORY' | translate)
					"
				>
					<mat-select-trigger class="text-main-color-black mx-12px">
						{{
							getController('subSubCategoryId')?.value
								? this.translate.currentLang == 'en'
									? subSubcategory?.name?.en
									: subSubcategory?.name?.ar
								: ''
						}}
					</mat-select-trigger>
					<div class="select-container">
						<mat-form-field
							class="w-[90%] ltr:ms-[12px] rtl:me-[12px] mt-2 bg-light-grey text-main-color-black relative overflow-hidden"
							appearance="outline"
						>
							<div>
								<img
									class="absolute ltr:left-[7px] rtl:right-[7px] inline-block top-[15px]"
									src="./assets/images/search-normal.svg"
									alt=""
								/>
							</div>
							<input
								matInput
								type="text"
								(keydown)="$event.stopPropagation()"
								[formControl]="keyWordSubSubCategory"
								placeholder="{{ 'OFFERS.SEARCH' | translate }}"
								class="absolute w-[80%] ltr:left-10 rtl:right-10"
							/>
							<img
								*ngIf="keyWordSubSubCategory.value"
								(click)="keyWordSubSubCategory.setValue('')"
								class="cursor-pointer absolute ltr:right-3 rtl:left-3 top-[15px] inline-block"
								src="./assets/images/close-square.svg"
								alt=""
							/>
						</mat-form-field>

						<div class="max-h-[250px] overflow-y-auto">
							<mat-option
								*ngFor="let option of subSubCategoryList"
								(click)="
									filterForm.controls['subSubCategoryId'].setValue(option.id);
									subSubcategory = option
								"
								[value]="option.id"
							>
								{{
									translate.currentLang == 'en'
										? option?.name?.en
										: option?.name?.ar
								}}
							</mat-option>
							<mat-option
								disabled
								class="only-check"
								*ngIf="!subSubCategoryList?.length"
							>
								{{ 'GENERAL.NO_DATA_FOUND' | translate }}
							</mat-option>
						</div>
					</div>
				</mat-select>
			</mat-form-field>
		</div>
		<div class="w-100 h-[1px] bg-secondry-color-Gray my-24px"></div>
		<!-- BRANDS  -->
		<div>
			<p class="text-[18px] ltr:font-DIN-Bold font-bold rtl:font-medium">
				{{ 'STORE.PRODUCT_LIST.BRAND_NAME' | translate }}
			</p>
			<mat-form-field appearance="outline" class="w-full custom-autocomplete">
				<button matSuffix mat-icon-button>
					<img class="w-3" src="assets/images/arrow.png" />
				</button>

				<mat-select
					panelClass=" my-0 mx-24px custom-ed-hight custom-width"
					formControlName="brandId"
					[placeholder]="
						getController('brandId')?.value
							? translate.currentLang == 'en'
								? brandValue?.name?.en
								: brandValue?.name?.ar
							: ('STORE.PRODUCT_LIST.BRAND_NAME' | translate)
					"
				>
					<mat-select-trigger class="text-main-color-black mx-2">
						{{
							this.translate.currentLang == 'en'
								? brandValue?.name?.en
								: brandValue?.name?.ar
						}}
					</mat-select-trigger>
					<div class="select-container">
						<mat-form-field
							class="w-[90%] ltr:ms-[12px] rtl:me-[12px] mt-2 bg-light-grey text-main-color-black relative overflow-hidden"
							appearance="outline"
						>
							<div>
								<img
									class="absolute ltr:left-[7px] rtl:right-[7px] inline-block top-[15px]"
									src="./assets/images/search-normal.svg"
									alt=""
								/>
							</div>
							<input
								matInput
								type="text"
								(keydown)="$event.stopPropagation()"
								[formControl]="keywordBrand"
								placeholder="{{ 'OFFERS.SEARCH' | translate }}"
								class="absolute w-[80%] ltr:left-10 rtl:right-10"
							/>
							<img
								*ngIf="keywordBrand.value"
								(click)="keywordBrand.setValue('')"
								class="cursor-pointer absolute ltr:right-3 rtl:left-3 top-[15px] inline-block"
								src="./assets/images/close-square.svg"
								alt=""
							/>
						</mat-form-field>

						<div class="overflow-y-auto custom-mat-option">
							<mat-option
								*ngFor="let option of Brands"
								(click)="
									filterForm.controls['brandId'].setValue(option.id);
									brandValue = option
								"
								[value]="option.id"
							>
								{{
									translate.currentLang == 'en'
										? option?.name?.en
										: option?.name?.ar
								}}
							</mat-option>
							<mat-option disabled class="only-check" *ngIf="!Brands?.length">
								{{ 'GENERAL.NO_DATA_FOUND' | translate }}
							</mat-option>
						</div>
					</div>
				</mat-select>
			</mat-form-field>
		</div>
		<div class="w-100 h-[1px] bg-secondry-color-Gray my-24px"></div>

		<div>
			<p
				class="text-dark-grey text-font-18 ltr:font-DIN-Bold font-bold rtl:font-medium leading-[22px]"
			>
				{{ 'STORE.PRODUCT_LIST.STOCK_AVAILABILITY' | translate }}
			</p>
			<mat-radio-group
				aria-label="Select an option"
				formControlName="inStockOnly"
			>
				<mat-radio-button
					[value]="true"
					class="ltr:mr-[24px] rtl:ml-[24px] text-font-14 text-dark-grey"
					>{{ 'STATUS.INSTOCK' | translate }}</mat-radio-button
				>
				<mat-radio-button class="text-font-14 text-dark-grey" [value]="false">{{
					'STATUS.OUTOFSTOCK' | translate
				}}</mat-radio-button>
			</mat-radio-group>
		</div>
		<div class="w-100 h-[1px] bg-secondry-color-Gray my-24px"></div>
		<div>
			<p
				class="text-dark-grey text-font-18 ltr:font-DIN-Bold font-bold rtl:font-medium leading-[22px]"
			>
				{{ 'STORE.PRODUCT_FILTER.GENDER' | translate }}
			</p>

			<div *ngFor="let status of genders">
				<div>
					<mat-checkbox
						(change)="statusChanged($event, 'gender')"
						[value]="status?.value"
						class="ltr:mr-2 rtl:ml-2 mb-[19px]"
						[checked]="getController('gender')?.value?.includes(status?.value)"
					>
					</mat-checkbox>
					{{ 'GENERAL_LABELS.' + status['name'].toUpperCase() | translate }}
				</div>
			</div>
		</div>
		<div class="w-100 h-[1px] bg-secondry-color-Gray my-24px"></div>
		<div class="pb-48px">
			<p
				class="text-dark-grey text-font-18 ltr:font-DIN-Bold font-bold rtl:font-medium leading-[22px]"
			>
				{{ 'GENERAL_LABELS.PRICE' | translate }}
			</p>
			<div>
				<div class="flex justify-center items-center" appearance="outline">
					<mat-form-field class="w-[45%] mb-[30px]" appearance="outline">
						<mat-label> {{ 'CLIENT.FILTER.MINIMUM' | translate }}</mat-label>
						<input
							(wheel)="$event.preventDefault()"
							type="number"
							formControlName="priceFrom"
							matInput
							(keypress)="allowOnlyNumbers($event)"
						/>
					</mat-form-field>
					<span class="mx-[6px] mb-[30px]">-</span>
					<mat-form-field class="w-[45%] mb-[30px]" appearance="outline">
						<mat-label> {{ 'CLIENT.FILTER.MAXIMUM' | translate }}</mat-label>
						<input
							(wheel)="$event.preventDefault()"
							type="number"
							[min]="+filterForm?.get('priceFrom')?.value + 1"
							formControlName="priceTo"
							matInput
							(keypress)="allowOnlyNumbers($event)"
						/>
					</mat-form-field>
				</div>
				<mat-error>
					<validation-message
						[controller]="getController('priceFrom')"
						controller_name="CLIENT.FILTER.MINIMUM"
					>
					</validation-message>
				</mat-error>
				<mat-error>
					<validation-message
						[controller]="getController('priceTo')"
						controller_name="CLIENT.FILTER.MAXIMUM"
					>
					</validation-message>
				</mat-error>
			</div>
		</div>
		<button
			[disabled]="
				filterCount == 0 ||
				(getController('dateTo').value < getController('dateFrom').value &&
					getController('dateTo').value) ||
				(getController('priceTo').value < getController('priceFrom').value &&
					getController('priceTo').value)
			"
			class="bg-gradient text-white w-[89%] p-0 absolute bottom-2"
			mat-button
			(click)="submit()"
		>
			{{ 'ACTIONS.APPLY_FILTER' | translate }}
		</button>
	</div>
</div>
